import React, { Component } from "react";
import service from '../services';
// Images import
import serachIcon from "../assets/images/search.svg";

import cloud from "../assets/images/cloud.svg";
import { Link } from "react-router-dom";
import moment from 'moment-timezone'


import ReceiptModal from './ReceiptModal';
import UserActivitiesModal from './UserActivitiesModal';
import Loader from "./loader";
import axios from 'axios';
import PurchaseUser from './useractivities/PurchaseUser';
import Reservation from './useractivities/Reservation';
import PassTicktes from './useractivities/passesTickects';
import ScreeningUser from './useractivities/ScreeningUser';
import { from } from "rxjs";
import TalksEvents from "./useractivities/TalksEvents";
import TheaterDetails from "./useractivities/TheaterDetails";
import Allotments from "./useractivities/Allotments";
import Voting from "./useractivities/Voting";
import SimpleReactValidator from 'simple-react-validator';
import { ActCreators } from '../redux/bindActionCretor';
import { bindActionCreators } from 'redux';
import { connect } from "react-redux";
import _ from 'lodash'

let itemsWiseFilterData = [];
let roleWiseFilterData = [];
let sub;
let FilmTypeFilterData = [];
let screeningTypeFilterData = [];
let screeningTypeOnlineFilterData = [];
let locationFilter = [];
let typeWiseFilterData =[];
let screeningFilmFilterData = [];
let sourceFilterData = [];
let programFilterList = [];
const mapStateToProps = state => ({
    Searchvalue: state.Searchvalue,
    searchLocation: state.searchLocation
  });
  
  const mapDispatchToProps = dispatch => {
    return bindActionCreators(ActCreators, dispatch);
  };
class UserActivities extends Component {

    constructor(props) {
        super(props)
        this.validator = new SimpleReactValidator({ autoForceUpdate: this });
        this.state = {
            fromDate: new Date(),
            toDate: new Date(),
            TalkandEventtoDate: new Date(),
            TalkandEventtoDate: new Date(),
            dateFilterModal: false,
            TalkandEventFilterModal: false,
            dateTimeFilterModal:false,
            purchaseReceipt: false,
            userActivities: false,
            dateDisplayFlag: false,
            TalkandEventFlag: false,
            TheaterDatetimeFlag:false,
            dateState: false,
            Datetime:false,
            TalkandEvent: false,
            getAllUserActivities: [],
            purchaseList: [],
            searchField: '',
            typing: false,
            typingTimeout: 0,
            searchText: '',
            filmFilterType: [],
            allotmentData:[],
            rolesType: [
                { assign: "sioUser", name: "Industry", value: false },
                { assign: "pressUser", name: "Press", value: false },
                // { assign: "circleUser", name: "Sundance Circle", value: false },
                { assign: 'generalUser', name: 'General', value: false },
                { assign: 'circleGuestUser', name: 'Sundance Guest', value: false },
                { assign: 'artistUser', name: 'Artist', value: false },
            ],
            screeningType: [
                { assign: "1", name: "Premiere", value: false },
                { assign: "2", name: "Second Screening", value: false },
                { assign: "3", name: "Award Winner", value: false },
                { assign: "4", name: "Private Screening", value: false },
                { assign: '5', name: 'Indies Series', value: false },
                { assign: '6', name: 'Short Program', value: false },
            ],
            screeningOnlineType: [
                { assign: "1", name: "Premiere", value: false },
                { assign: "2", name: "Second Screening", value: false },
                { assign: "3", name: "Award Winner", value: false },
                { assign: '4', name: 'Indies Series', value: false },
                { assign: '5', name: 'Shorts', value: false },
                { assign: '6', name: 'My Library', value: false },

            ],
            itemsType: [
                { assign: "hybridAllAccessPass", name: "All Access Pass", value: false },
                { assign: "hybridAllAccessPassFirstHalf", name: "All Access Pass 1st half Pass", value: false },
                { assign: "hybridAllAccessPassSecondHalf", name: "All Access Pass 2nd half", value: false },
                { assign: 'onlineAllAccessPass', name: 'All Access Pass - Online only', value: false },
                { assign: 'hybridPressIndustryPackage', name: 'P&I Package', value: false },
                { assign: 'onlinePressIndustryPackage', name: 'P&I Package - Online only', value: false },
                { assign: 'hybridFestivalPass', name: 'Festival Package', value: false },
                { assign: 'onlineDayPass', name: 'Day Package - Online only', value: false },
                { assign: 'hybridResortPackage', name: 'Resort Package', value: false },
                { assign: 'saltLackCityPackage', name: 'SLC Package', value: false },
                { assign: 'hybridAwardWinnersPass', name: 'Award Winners Weekend', value: false },
                { assign: 'hybridSingleFilmTicket', name: 'Single Ticket', value: false },
                { assign: 'onlineExplorerPass', name: 'Explorer Pass - Online only', value: false },
            ],
            TalkandEventType: [
                { assign: "BeyondFilm", name: "Beyond Film ", value: false },
                { assign: "Frontier", name: "New Frontier", value: false },
                { assign: 'PartnerEvent', name: 'Partner Event', value: false },
                { assign: 'PrivateEvent', name: 'Private Event', value: false },
                { assign: 'ShortProgramme', name: ' Short Programme', value: false },
            ],
            sourceType: [
                { assign: true, name: "OTT", value: false },
                { assign: false, name: "Web", value: false },
            ],
            // pagination variable diclaration start
            offset: 0,
            perPage: 50,
            currentPage: 0,
            totalPages: 0,
            // pagination variable diclaration end
            activetab: 5,
            userlist: [
                { "label": "Allotments"},
                { "label": "Talks & Events"},
                { "label": "Theater Details"},
                { "label": "Online Screenings"},
                { "label": "Voting"},
                { "label": "Product Sales"},
                // { "label": "Reservations"},
                { "label": "Purchases"},
            ],
            email:""
        } 
        this.closeModal = this.closeModal.bind(this);
        this.apiserve = new service();
    }

    componentWillUnmount = () => {
        sub.unsubscribe();
        itemsWiseFilterData = [];
        programFilterList = []
    }




    componentDidMount = async () => {
        const { getLoginAdminByID, getLoginRole } = this.props
        var self = this
        let currentPage = localStorage.getItem('currentPage')
        if(currentPage) {
        this.setState({
          offset: parseInt(localStorage.getItem("offset")),
          perPage: parseInt(localStorage.getItem("perPage")),
          currentPage: parseInt(localStorage.getItem("currentPage")),
        },() =>
             this.getUserActivities(this.state.offset, this.state.perPage)
        );
        }else{
                this.setState({
            offset:0,
            perPage:50,
            currentPage:0
        },() =>
             this.getUserActivities(this.state.offset, this.state.perPage))
        }
        this.setState({
            loaderFlag: true,
        });
        this.apiserve.sendevent("admin|getFilmTitles", {});
        this.apiserve.sendevent("location|exploreList", {});
        this.apiserve.sendevent("admin|getUserScreeningFilmList", {});
        this.apiserve.sendevent("user|sff|getAllInitial", {});
        // this.apiserve.sendevent("admin|screening|getGrandTotalScreening", {});
        sub = this.apiserve.getevent().subscribe((response) => {
            // 
            switch (response.event) {
                case "admin|getUserActivities":
                    if (!response.error) {
                        this.setState({
                            getAllUserActivities: response.data.docs,
                            getTotalDocs: response.data.totalDocs,
                            getTotalDocsActivities: response.data.totalDocs,
                            pageCount: Math.ceil(response.data.totalDocs / this.state.perPage),
                            totalPages: response.data.totalPages || 0
                        }, () => {
                            this.setState({
                                loaderFlag: false,
                                dateFilterModal: false,

                            })
                        })
                    } else {
                        this.apiserve.error(response.data.error ? response.data.error : response.data)
                    }
                    break;
                case 'admin|getUserScreening':
                    if (!response.error) {
                        this.setState({
                            loaderFlag: false,
                            // getAllUserActivities: response.data.docs,
                            getTotalDocs: response.data.totalDocs,
                            // pageCount: Math.ceil(response.data.totalDocs / this.state.perPage),
                            // totalPages: response.data.totalPages || 0
                            // }, () => {
                            //     this.setState({
                            //         loaderFlag: false,
                            //         dateFilterModal: false
                            //     })
                        })
                    } else {
                        this.apiserve.error(response.data.error ? response.data.error : response.data)
                    }
                    break;
                case 'admin|getUseranalytics':
                    if (!response.error) {
                        this.setState({
                            // getAllUserActivities: response.data.docs,
                            getTotalDocs: response.data.totalDocs,
                            // pageCount: Math.ceil(response.data.totalDocs / this.state.perPage),
                            // totalPages: response.data.totalPages || 0
                        }, () => {
                            this.setState({
                                loaderFlag: false,
                                TalkandEventFilterModal: false,
                                dateTimeFilterModal:false
                            })
                        })
                    } else {
                        this.apiserve.error(response.data.error ? response.data.error : response.data)
                    }
                    break;
                case "orderSummary|getDetail":
                    if (!response.error) {
                        this.setState({
                            purchaseList: [],

                        }, () => {
                            this.setState({
                                loaderFlag: false,
                                purchaseReceipt: true,
                                purchaseList: [...this.state.purchaseList, response.data]
                            })
                        })
                    } else {
                        this.apiserve.error(response.data.error)
                    }
                    break;
                // case "admin|screening|getList":
                //         if (!response.error) {
                //             this.setState({
                //                 loaderFlag: false,
                //             });
                //         } else {
                //             this.setState({
                //                 loaderFlag: false,
                //             });
                //         }
                //         break;
                case "admin|userActivityCSV|purchase":
                case "admin|userActivityCSV|otherTab":
                case "admin|userActivityCSV|allotmentCSV":
                case 'admin|getFilmTitles':
                    if (!response.error) {

                        let FilmTypeFilterDatas = response.data.map((item,i)=>{
                            return ({
                                'name': item.title,
                                'id': item._id,
                                // 'value' : false,
                                'assign':i+1
                            })                                
                        })
                        this.setState({
                            // FilmTypeFilterData: FilmTypeFilterDatas,
                            OrignalData:FilmTypeFilterDatas,                               
                        }, () => {
                            this.setState({
                              
                                dateTimeFilterModal: false
                            })
                        })
                       } else {
                        this.apiserve.error(response.data.error ? response.data.error : response.data)
                    }
                    break;
                case 'location|exploreList':
                    if (!response.error) {
                         let locationsFilters = response.data.map((item,i)=>{
                            return ({
                                'name': item.name,
                                'id': item._id,
                                // 'value' : false,
                                'assign':i+1
                            })                                
                        })
                        // locationFilter = [...new Map(locationFilter.map(item => [item.id, item])).values()];
                        this.setState({
                            // locationFilter:locationsFilters,
                            LocationData:locationsFilters,
                            // loaderFlag: false,
                        })
                    } else {
                        this.apiserve.error(response.data.error ? response.data.error : response.data)
                    }
                    break;
                case 'admin|userActivityCSV|screening':
                        this.setState({loaderFlag : false})
                        this.closeModal()
                    break;
                case "admin|getUserScreeningFilmList":
                    if (!response.error) {
                        const list = _.remove(response.data, function (e) {
                            return e.name != undefined
                        });
                        this.setState({
                            filmFilterType: list
                        }, () => {
                            this.setState({
                                loaderFlag: false,
                            })
                        })
                    } else {
                        this.apiserve.error(response.data.error ? response.data.error : response.data)
                    }
                    break;
                case "user|sff|getAllInitial":
                    var programData =  response.data.film && response.data.film.category.map(function (el) {
                            let o = Object.assign({}, el);
                            o.value = false;
                            return o;
                        });
                        var awardCategoryData =  response.data.film && response.data.film.awardCategory.map(function (el) {
                            let o = Object.assign({}, el);
                            o.value = false;
                            return o;
                        });
                        // setFilmList(response?.data?.film)
                        this.setState({
                          
                            programArray:programData.filter(_=>_.type !== 2  && _.type !== 3 ),
                            categoryArray:response?.data?.film?.category
                        })
                        
                        let currentPage = localStorage.getItem('currentPage')
                        if(currentPage) {
                            this.setState({
                                offset:parseInt(localStorage.getItem("offset")),
                                perPage:parseInt(localStorage.getItem("perPage")),
                                currentPage:parseInt(localStorage.getItem("currentPage"))
                            })
                            if(this.state.activetab === 0){
                                this.getFilmList(parseInt(localStorage.getItem("offset")),parseInt(localStorage.getItem("perPage")))
                            }
                        }else{
                            this.setState({
                                offset:this.state.offset,
                                perPage:this.state.perPage,
                                currentPage:this.state.currentPage
                            })
                            if(this.state.activetab === 0){
                                this.getFilmList(this.state.offset,this.state.perPage)
                            }
                    }
                    break;
                // case "admin|screening|getGrandTotalScreening":
                //     if (!response.error) {
                //         this.setState({
                //             loaderFlag: false,
                //             grandtotal:response?.data?.grandTotal
                //         })
                //     }else{
                //         this.setState({
                //             loaderFlag: false
                //         })
                //     }
                //     break;
                case "admin|screening|getList":
                    if (!response.error) {
                        this.setState({
                            loaderFlag: false,
                            pageCount:response?.data?.filmDetails?.totalDocs / this.state.perPage,
                            allotmentData:response?.data?.filmDetails?.docs
                        })
                    } else {
                        this.setState({
                            loaderFlag: false
                        })
                    }
                    break;
                case "admin|screening|getScreeningList":
                    if (!response.error) {
                        this.setState({
                            loaderFlag: false,
                            filmDetail :response?.data?.filmDetails
                        })
                    }
                    break;
                default:
                    break;
            }
        });
        // this.getUserActivities(this.state.offset, this.state.perPage);
        this.setState({
            loaderFlag: true,
        });
    }
    getFilmList = (skip, limit) => {
        this.setState({
            loaderFlag:true
        })
        var data = {}
       
        if (programFilterList && programFilterList.length) {
            data.category = programFilterList
        }
        data.page = skip
        data.limit = limit
        this.apiserve.sendevent("admin|screening|getList", data)
    }

    programFilter = (e, selectedInex,isClearStatusType ,isClearProgramType = false) => {
        
        let index = selectedInex
        let event = e && e.target && e.target.checked
        let approvePassList = this.state.programArray
        approvePassList.forEach((key, i) => {
            
           
            if(i === index) {
                
                approvePassList[i].value = event
            }
            if(isClearProgramType) {
                approvePassList[i].value = false
                programFilterList=[]
            }
            this.setState({
              
                programArray:approvePassList,
                currentPage:0
            })
            if (event) {
                if (index !== null) {
                    if(!programFilterList.includes(this.state.programArray[index]._id)){
                        programFilterList = [...programFilterList, this.state.programArray[index]._id];
                    }
                }
            } else {
                if (index !== null) {
                    let tempArray = programFilterList.filter((d) => d !== this.state.programArray[index]._id);
                    programFilterList = tempArray; 
                }
            }
        })
        this.getFilmFilter(this.state.offset, this.state.perPage,isClearStatusType,isClearProgramType);
    }
    getFilmFilter = (skip,limit,isClearStatusType,isClearProgramType,isClearAwardType) =>{
        
        let data = {
            page: 1,
            limit: limit
        }
        if (!isClearProgramType && programFilterList && programFilterList.length) {
            data.category = programFilterList
        }
        this.apiserve.sendevent("admin|screening|getList", data);
    }

    getAlotment = (e,filmId) => {
        if(filmId === this.state.dropdownId){	
            this.setState({
                dropdownId:''
            })
        }else{
            this.setState({
                dropdownId:filmId,
                loaderFlag:true
            })	
            let data = {filmId:filmId}
            this.apiserve.sendevent("admin|screening|getScreeningList", data);
        }
    }
    getUserActivities = (skip, limit) => {
        var data = {}
        if (this.state.searchField.length) {
            data.filter = this.state.searchField
        }

        if (roleWiseFilterData.length) {
            data.role = roleWiseFilterData
        }

        if (itemsWiseFilterData.length) {
            data.pass = itemsWiseFilterData
        }

        if (this.state.dateState || this.state.Datetime) {
            let fromDate = moment(this.state.fromDate).startOf('day').toString();
            let toDate = moment(this.state.toDate).endOf('day').toString();

            data.fromDate = fromDate
            data.toDate = toDate
        }

        data.page = skip
        data.limit = limit
        if(this.state.activetab === 0){
            data.tab = 0
            if (programFilterList && programFilterList.length) {
                data.category = programFilterList
            }
            this.setState({loaderFlag:true})
            this.apiserve.sendevent("admin|screening|getList", data);
        } else if(this.state.activetab === 1){
            data.tab = 1
            this.setState({loaderFlag:true})
            this.apiserve.sendevent("admin|getUseranalytics", data);
        } else if(this.state.activetab === 2){
            if (screeningTypeFilterData.length) {
                data.screenType = screeningTypeFilterData
            }
            if (FilmTypeFilterData.length) {
                data.film = FilmTypeFilterData
            }
            if(locationFilter.length) {
                data.location = locationFilter
            }
            data.tab = 2
            delete data['pass']
            this.setState({loaderFlag:true})
            this.apiserve.sendevent("admin|getUseranalytics", data);
            this.apiserve.sendevent("admin|getScannedCount", {});
        } else if (this.state.activetab === 4) {
            data.tab = 4
            this.apiserve.sendevent("admin|getUseranalytics", data);
        } else if (this.state.activetab === 3){ 
            if (screeningFilmFilterData.length) {
                data.film = screeningFilmFilterData
            }
    
            if (screeningTypeOnlineFilterData.length) {
                data.screenType = screeningTypeOnlineFilterData
            }
    
            if (sourceFilterData.length) {
                data.source = sourceFilterData
            }
            
            this.apiserve.sendevent("admin|getUserScreening", data);
        } else {
            this.apiserve.sendevent("admin|getUserActivities", data);
        }
    }

    closeModal = () => {
        this.validator.hideMessages()
        this.setState({
            dateFilterModal: false,
            TalkandEventFilterModal: false,
            purchaseReceipt: false,
            userActivities:false,
            email:''
        })
        this.validator.hideMessages()
    }
    closeTalkandEventModal = () => {
        this.setState({
            TalkandEventFilterModal: false,
        })
    }
    DatetimecloseModal=()=>{
        this.setState({
            dateTimeFilterModal: false,
        })
    }
    OpenDateFilter = () => {
        this.setState({
            dateFilterModal: true
        })
    }
    OpenTalkandEventDateFilter = () => {
        this.setState({
            TalkandEventFilterModal: true
        })
    }
    OpenTheaterDatetimeDateFilter=()=>{
         this.setState({
            dateTimeFilterModal: true
        })
    }
    clearDateFilter = () => {

        this.setState({ loaderFlag: true, dateDisplayFlag: false, dateState: false })
        var data = {}

        if (this.state.searchField.length) {
            data.filter = this.state.searchField
        }

        if (roleWiseFilterData.length) {
            data.role = roleWiseFilterData
        }

        if (itemsWiseFilterData.length) {
            data.pass = itemsWiseFilterData
        }

        data.page = 1
        data.limit = 50
        this.apiserve.sendevent("admin|getUserActivities", data);
    }
    TalkandEventclearDateFilter = () => {

        this.setState({ loaderFlag: true, TalkandEventFlag: false, TalkandEvent: false })
        var data = {}

        if (this.state.searchField.length) {
            data.filter = this.state.searchField
        }

        if (roleWiseFilterData.length) {
            data.role = roleWiseFilterData
        }

        if (itemsWiseFilterData.length) {
            data.pass = itemsWiseFilterData
        }
        if (typeWiseFilterData.length) {
            data.filmType = typeWiseFilterData
        }

        data.page = 1
        data.limit = 50
        data.tab = 1
        this.apiserve.sendevent("admin|getUseranalytics", data);
    }
    //Theater Search Data 
    onSearchFilters = (e) => {
        if (this.state.typingTimeout) {
            clearTimeout(this.state.typingTimeout);
        }
        const { name, value } = e.target
        const Value = value
        let self = this
        this.setState({
            [e.target.name]: e.target.value,
            currentPage:0,
        });
        this.setState({loaderFlag:true})
        this.setState({
            typing: false,
            typingTimeout: setTimeout(function () {
                var data = {}
                if (Value.length) {
                    data = {
                        page: 1,
                        limit: 50,
                        filmFilter: Value,
                    }
                }
                if (self.state.searchFilmField.length) {
                    data.filmFilter = self.state.searchFilmField
                 }
                 data.tab = 2
                 data.limit=50
                 self.apiserve.sendevent("admin|getUseranalytics", data);
            },1500)
    })}
    TheaterDatetimeclearDateFilter=()=>{
        this.setState({ loaderFlag: true, TheaterDatetimeFlag: false, Datetime: false })
        var data = {}

        if (this.state.searchField.length) {
            data.filter = this.state.searchField
        }

        if (roleWiseFilterData.length) {
            data.role = roleWiseFilterData
        }

        if (screeningTypeFilterData.length) {
            data.screenType = screeningTypeFilterData
        }
        // if (itemsWiseFilterData.length) {
        //     data.pass = itemsWiseFilterData
        // }

        if (FilmTypeFilterData.length) {
            data.film = FilmTypeFilterData
        }

        data.page = 1
        data.limit = 50
        data.tab = 2
        this.apiserve.sendevent("admin|getUseranalytics", data);
    }
    OpenReceiptModal = (id) => {
        this.setState({
            loaderFlag: true
        })
        var data = {
            id: id
        }
        this.apiserve.sendevent("orderSummary|getDetail", data)
    }
    OpenUserActiviesModal = (id) => {
        this.setState({
            purchaseReceipt: true,
        })
    }

    itemsScreeningTypeFilter = (e, selectedInex, isClearRoleType, isClearItemType = false) => {

        let index = selectedInex
        let event = e && e.target && e.target.checked
        let itemsList = [...this.state.filmFilterType]
        itemsList.forEach((key, i) => {
            if (i === index) {
                itemsList[i].value = event
            }
            if (isClearItemType) {
                itemsList[i].value = false
                screeningFilmFilterData = []
            }

        })
        this.setState({
            ...this.state,
            filmFilterType: itemsList,
            currentPage: 0
        }, () => {
            if (event) {
                if (index !== null) {
                    screeningFilmFilterData = [...screeningFilmFilterData, this.state.filmFilterType[index]._id];
                }
            } else {
                if (index !== null) {
                    let tempArray = screeningFilmFilterData.filter((d) => d !== this.state.filmFilterType[index]._id);
                    screeningFilmFilterData = tempArray;
                }
            }
            this.getAllItemFilter(this.state.offset, this.state.perPage);
        })
    }

    //Pagination Click
    handlePageClick = (e) => {
        // 
        const selectedPage = e.selected;
        const offset = selectedPage + 1;
        this.setState(
            {
                currentPage: selectedPage,
                offset: offset,
                loaderFlag: true
            },
            () => {
                localStorage.setItem('currentPage',this.state.currentPage)
                localStorage.setItem('offset',offset)
                localStorage.setItem('perPage',this.state.perPage)
                this.getUserActivities(offset, this.state.perPage, this.state.searchField, itemsWiseFilterData);
            }
        );
    };

    //Search Data
    onSearchFilter = (e) => {
        if (this.state.typingTimeout) {
            clearTimeout(this.state.typingTimeout);
        }

        const { name, value } = e.target
        const Value = value
        const activetab = this.state.activetab
       
        let self = this
        this.setState({
            [e.target.name]: e.target.value,
            currentPage: 0
        })
        this.forceUpdate()
        this.setState({
            typing: false,
            // loaderFlag:true,
            typingTimeout: setTimeout(function () {
                // if (Value !== '') {

                var data = {}
                if (Value.length) {
                    data = {
                        page: 1,
                        limit: 50,
                        filter: Value,
                    }
                }
                if (roleWiseFilterData.length) {
                    data.role = roleWiseFilterData
                }

                if (itemsWiseFilterData.length) {
                    data.pass = itemsWiseFilterData

                }
                if (activetab === 1||activetab === 2||  activetab === 4) {
                    data.tab = activetab 
                    self.apiserve.sendevent("admin|getUseranalytics", data);
                }
                else if(activetab === 3 ){
                    self.apiserve.sendevent("admin|getUserScreening",data)
                }else if(activetab === 0 ){
                    self.apiserve.sendevent("admin|screening|getList",data)
                }
                else {
                    self.apiserve.sendevent("admin|getUserActivities", data);
                }

                // }
            }, 1500)
        });



        // this.setState({
        //     [e.target.name]: e.target.value,
        //     currentPage: 0
        // }, () => {

        // });
    }


    getCSVData = () => {
        // this.setState({
        //     loaderFlag: true
        // })
        let token = localStorage.getItem("loginToken")
        let role
        let pass
        let filter
        let fromDate
        let toDate
        if (roleWiseFilterData.length) {
            role = roleWiseFilterData
        }

        if (itemsWiseFilterData.length) {
            pass = itemsWiseFilterData

        }
        if (this.state.searchField.length) {
            filter = this.state.searchField;
        }

        var url = process.env.REACT_APP_SOCKET_API_KEY + `api/getUserActivities?${filter ? `filter=${filter}` : ''}${role ? `&role=${role}` : ''}${pass ? `&pass=${pass}` : ''}`

        if (this.state.dateState) {
            // fromDate = moment(new Date(this.state.fromDate)).utc().format('ddd MMM DD YYYY h:mm:ss Z')
            //  toDate = moment(new Date(this.state.toDate)).utc().format('ddd MMM DD YYYY h:mm:ss Z')
            fromDate = this.state.fromDate
            toDate = this.state.toDate
            fromDate.setHours(0)
            fromDate.setMinutes(0)
            toDate.setHours(23)
            toDate.setMinutes(59)
            fromDate = moment(this.state.fromDate).utc().toISOString()
            toDate = moment(this.state.toDate).utc().toISOString()
            // var fromDateCSV = moment(this.state.fromDate).format('YYYY-MM-DD')
            // var toDateDateCSV = moment(this.state.toDate).format('YYYY-MM-DD')

            // var fDate = fromDateCSV + "T00:00:00.000Z"
            // var tDate = toDateDateCSV + "T23:59:00.000Z"

            url = url + `${fromDate ? `&fromDate=${fromDate}` : ''}${toDate ? `&toDate=${toDate}` : ''}`
        }

        this.setState({
            userActivities: true,
        })
        // axios({
        //     url: url,
        //     method: 'get',
        //     headers: { 'Authorization': 'Bearer ' + token }
        // })
        //     .then(res => {
        //         let csvContent = "data:text/csv;charset=utf-8,"
        //             + res.data;
        //         var encodedUri = encodeURI(csvContent);
        //         var link = document.createElement("a");
        //         link.setAttribute("href", encodedUri);
        //         link.setAttribute("download", "userActivities.csv");
        //         document.body.appendChild(link);

        //         link.click()
        //         this.setState({
        //             loaderFlag: false
        //         })
        //     })
        //     .catch(err => {
        //         console.log("err : ", err);
        //     })
    }

    submitEmail = (e,from,to) => {
        // if (validator.current.allValid()) return true;
        // else {
        //     validator.current.showMessages();
        //     forceUpdate();
        // }
        // this.setState({loaderFlag : true})
        e.preventDefault();
        if (this.validator.allValid()) {
            // this.setState({loaderFlag : true})
            let data ={}
            data.email = this.state.email

            if (this.state.searchField.length) {
                data.filter = this.state.searchField
            }
    
            if (roleWiseFilterData.length) {
                data.role = roleWiseFilterData
            }
    
            if (itemsWiseFilterData.length) {
                data.pass = itemsWiseFilterData
            }
            
            if (this.state.dateState || this.state.Datetime || this.state.TalkandEvent) {
                let fromDate = new Date(this.state.fromDate)
                let toDate = new Date(this.state.toDate)
    
                fromDate.setHours(0)
                fromDate.setMinutes(0)
                toDate.setHours(23)
                toDate.setMinutes(59)
    
    
                data.fromDate = fromDate
                data.toDate = toDate
            }
            if(this.state.activetab === 0){
                if (programFilterList && programFilterList.length) {
                    data.category = programFilterList
                }
                delete data['pass']
                delete data['fromDate']
                delete data['toDate']
                this.apiserve.sendevent("admin|userActivityCSV|allotmentCSV", data);
            }
            if(this.state.activetab === 3){
                if (screeningFilmFilterData.length) {
                    data.film = screeningFilmFilterData
                }
                if (screeningTypeOnlineFilterData.length) {
                    data.screenType = screeningTypeOnlineFilterData
                }
                if (locationFilter.length) {
                    data.location = locationFilter
                    // data.location = []
                }
                delete data['fromDate'];
                delete data['toDate']
                this.apiserve.sendevent("admin|userActivityCSV|screening", data);
            } 
            if(this.state.activetab === 6){
                delete data['location']
                delete data['screenType']
                delete data['film']
                this.apiserve.sendevent("admin|userActivityCSV|purchase", data);
            } else if(this.state.activetab === 2 || this.state.activetab === 1 || this.state.activetab === 4){
                if(this.state.activetab === 1){
                    if (typeWiseFilterData.length) {
                        data.filmType = typeWiseFilterData
                    }
                }
                if (FilmTypeFilterData.length) {
                    data.film = FilmTypeFilterData
                }
                if (screeningTypeFilterData.length) {
                    data.screenType = screeningTypeFilterData
                }
                if (locationFilter.length) {
                    data.location = locationFilter
                    // data.location = []
                }
                delete data['pass']
                data.tab = this.state.activetab
                this.apiserve.sendevent("admin|userActivityCSV|otherTab", data);
            }
            this.setState({
                email: "",
                userActivities: false,
            });
            this.apiserve.success('You will receive an email shortly!')
        } else {
            this.setState({loaderFlag : false})
            this.validator.showMessages()
            this.forceUpdate();
        }
    }

    //Screening tyep filter
    screeningTypeFilter = (e, selectedInex, isClearRoleType = false, isClearItemType) => {
        let index = selectedInex
        let event = e && e.target && e.target.checked
        let screeningList = [...this.state.screeningType]
        screeningList.forEach((key, i) => {
            if (i === index) {
                screeningList[i].value = event
            }
            if (isClearItemType) {
                screeningList[i].value = false
                screeningTypeFilterData = []
            }

        })
        this.setState({
            ...this.state,
            count:0,
            screeningType: screeningList,
            currentPage: 0
        }, () => {
            if (event) {
                if (index !== null) {
                    screeningTypeFilterData = [...screeningTypeFilterData, this.state.screeningType[index].assign];
                }
            } else {
                if (index !== null) {
                    let tempArray = screeningTypeFilterData.filter((d) => d !== this.state.screeningType[index].assign);
                    screeningTypeFilterData = tempArray;
                }
            }
            this.getAllItemFilter(this.state.offset, this.state.perPage);
        })
    };

    // online screening
    screeningOnlineTypeFilter = (e, selectedInex, isClearRoleType = false, isClearItemType) => {
        let index = selectedInex
        let event = e && e.target && e.target.checked
        let screeningList = [...this.state.screeningOnlineType]
        screeningList.forEach((key, i) => {
            if (i === index) {
                screeningList[i].value = event
            }
            if (isClearItemType) {
                screeningList[i].value = false
                screeningTypeOnlineFilterData = []
            }

        })
        this.setState({
            ...this.state,
            count:0,
            screeningOnlineType: screeningList,
            currentPage: 0
        }, () => {
            if (event) {
                if (index !== null) {
                    screeningTypeOnlineFilterData = [...screeningTypeOnlineFilterData, this.state.screeningOnlineType[index].assign];
                }
            } else {
                if (index !== null) {
                    let tempArray = screeningTypeOnlineFilterData.filter((d) => d !== this.state.screeningOnlineType[index].assign);
                    screeningTypeOnlineFilterData = tempArray;
                }
            }
            this.getAllItemFilter(this.state.offset, this.state.perPage);
        })
    };

    //role wise filter
    LocationFilterdata =  (e, selectedInex, isClearRoleType,isClearLocationType=false) => {
        let index = selectedInex
        let event = e && e.target && e.target.checked
        let LocationList = [...this.state.LocationData]
        let LocationDatad=[...this.state.LocationData]
        var Arr = []
        LocationDatad.forEach((loca) => {
           
            if (loca.id === index) {
                loca.value = event
            }


            if (isClearLocationType) {
                loca.value = false
                // location.value = false
                locationFilter = []
            }
            Arr.push(loca)

        })

        this.setState({
            ...this.state,
            count:0,
            locationFilter: Arr,
            currentPage: 0
        }, () => {
            if (event) {
                if (index !== null) {
                    locationFilter = [...locationFilter, index];

                }
            } else {
                if (index !== null) {
                    let tempArray = locationFilter.filter((d) => d !== index);
                    locationFilter = tempArray;
                }
            }
            // this.setState({})
            this.getAllItemFilter(this.state.offset, this.state.perPage, isClearRoleType,isClearLocationType);
        })
    };
    
    handleChangeEmail = (e) =>{
        this.setState({email:e.target.value})
    }

    //role wise filter

    //role wise filter
    roleWiseFilter = (e, selectedInex, isClearRoleType = false, isClearItemType) => {
        let index = selectedInex
        let event = e && e.target && e.target.checked
        let roleList = [...this.state.rolesType]
        roleList.forEach((key, i) => {
            if (i === index) {
                roleList[i].value = event
            }
            if (isClearRoleType) {
                roleList[i].value = false
                roleWiseFilterData = []
            }

        })
        this.setState({
            ...this.state,
            rolesType: roleList,
            currentPage: 0
        }, () => {
            if (event) {
                if (index !== null) {
                    roleWiseFilterData = [...roleWiseFilterData, this.state.rolesType[index].assign];
                }
            } else {
                if (index !== null) {
                    let tempArray = roleWiseFilterData.filter((d) => d !== this.state.rolesType[index].assign);
                    roleWiseFilterData = tempArray;
                }
            }
            this.getAllItemFilter(this.state.offset, this.state.perPage, isClearRoleType, isClearItemType);
        })
    };

    itemsTypeFilter = (e, selectedInex, isClearRoleType, isClearItemType = false) => {

        let index = selectedInex
        let event = e && e.target && e.target.checked
        let itemsList = [...this.state.itemsType]
        itemsList.forEach((key, i) => {
            if (i === index) {
                itemsList[i].value = event
            }
            if (isClearItemType) {
                itemsList[i].value = false
                itemsWiseFilterData = []
            }

        })
        this.setState({
            ...this.state,
            itemsType: itemsList,
            currentPage: 0
        }, () => {
            if (event) {
                if (index !== null) {
                    itemsWiseFilterData = [...itemsWiseFilterData, this.state.itemsType[index].assign];
                }
            } else {
                if (index !== null) {
                    let tempArray = itemsWiseFilterData.filter((d) => d !== this.state.itemsType[index].assign);
                    itemsWiseFilterData = tempArray;
                }
            }
            this.getAllItemFilter(this.state.offset, this.state.perPage, isClearRoleType, isClearItemType);
        })
    }

    dateFilter = (from, to) => {
        this.setState({ loaderFlag: true, dateDisplayFlag: true })
        var data = {}

        if (this.state.searchField.length) {
            data.filter = this.state.searchField
        }

        if (roleWiseFilterData.length) {
            data.role = roleWiseFilterData
        }

        if (itemsWiseFilterData.length) {
            data.pass = itemsWiseFilterData
        }


        let fromDate = moment(from).startOf('day').toString()
        let toDate = moment(to).endOf('day').toString()

        // fromDate.setHours(0)
        // fromDate.setMinutes(0)
        // toDate.setHours(23)
        // toDate.setMinutes(59)

        data.page = 1
        data.limit = 50
        data.fromDate = fromDate
        data.toDate = toDate
        this.apiserve.sendevent("admin|getUserActivities", data);
        this.setState({ dateState: true })
    }
    TalkandEventdateFilter = (from, to) => {
        this.setState({ loaderFlag: true, TalkandEventFlag: true })
        var data = {}

        if (this.state.searchField.length) {
            data.filter = this.state.searchField
        }

        if (roleWiseFilterData.length) {
            data.role = roleWiseFilterData
        }
        if (typeWiseFilterData.length) {
            data.filmType = typeWiseFilterData
        }
        // if (itemsWiseFilterData.length) {
        //     data.pass = itemsWiseFilterData
        // }
        let fromDate = new Date(from)
        let toDate = new Date(to)

        fromDate.setHours(0)
        toDate.setMinutes(0)
        toDate.setHours(23)
        toDate.setMinutes(59)

        data.page = 1
        data.limit = 50
        data.tab = 1
        data.fromDate = fromDate
        data.toDate = toDate
        this.apiserve.sendevent("admin|getUseranalytics", data);
        this.setState({ TalkandEvent: true })
    }

    TheaterdateFilter=(from, to)=>{
        this.setState({ loaderFlag: true, TheaterDatetimeFlag: true })
        var data = {}

        if (this.state.searchField.length) {
            data.filter = this.state.searchField
        }

        if (roleWiseFilterData.length) {
            data.role = roleWiseFilterData
        }

        if (FilmTypeFilterData.length) {
            data.film = FilmTypeFilterData
        }
        if (screeningTypeFilterData.length) {
            data.screenType = screeningTypeFilterData
        }
        if (locationFilter.length) {
            data.location = locationFilter
            // data.location = []
        }
        // if (itemsWiseFilterData.length) {
        //     data.pass = itemsWiseFilterData
        // }
        let fromDate = new Date(from)
        let toDate = new Date(to)

        fromDate.setHours(0)
        toDate.setMinutes(0)
        toDate.setHours(23)
        toDate.setMinutes(59)

        data.page = 1
        data.limit = 50
        data.tab = 2
        data.fromDate = fromDate
        data.toDate = toDate
        this.apiserve.sendevent("admin|getUseranalytics", data);
        this.setState({ Datetime: true })
    }
    FilmTypeFilter =  (e, filmId, isClearRoleType, isClearItemType,isClearFilmItemType=false) => {
        let index = filmId
        
        
          let event = e && e.target && e.target.checked
          let filmList = [...this.state.OrignalData]
          let OrginalList = [...this.state.OrignalData]
          var Arr = []
           OrginalList.forEach((film,i) => {
              if (film.id === index) {
                  film.value = event
              }
  
  
              if (isClearFilmItemType) {
                  film.value = false
                  FilmTypeFilterData = []
              }
              Arr.push(film)
  
          })
  
          if (isClearFilmItemType) {
              this.props.dispatch({type: 'Searchvalue', res: ''})
               this.setState({
                  searchFilm : ''
              }, () => { this.setState({ searchFilm: '' }) })
           }
          this.setState({
              ...this.state,
              count:0,
              FilmTypeFilterData: Arr,
              currentPage: 0
          }, () => {
            if (event) {
                  if (index !== null) {
                     
                      FilmTypeFilterData = [...FilmTypeFilterData, index];
                  }
              } else {
                  if (index !== null) {
                      let tempArray = FilmTypeFilterData.filter((d) => d !== index);
                      FilmTypeFilterData = tempArray;
                  }
              }
              // this.setState({})
              this.getAllItemFilter(this.state.offset, this.state.perPage, isClearRoleType, isClearItemType,isClearFilmItemType);
          })
      };

      // search OrignalData
    onSearchfilmFilters = (e) => {
        const {name,value}= e.target
     this.setState({searchFilm:value})
     this.props.dispatch({type: 'Searchvalue', res: value})
     let olddata = this.state.OrignalData.filter((item)=> {
         return item.name.toLowerCase().includes(value.toLowerCase()) 
        })
        this.setState({OrignalData:olddata})
        this.forceUpdate()
        
        if(value === ''){
            this.apiserve.sendevent("admin|getFilmTitles", {});
        }
    }
    onSearchlocationFilters = (e) => {
        const {name,value}= e.target
        this.setState({searchLocation:value})
        this.props.dispatch({type: 'searchLocation', res: value})
    let olddata = this.state.LocationData.filter((item)=> {
      return item.name.toLowerCase().includes(value.toLowerCase()) 
    })
     this.setState({LocationData:olddata})
     this.forceUpdate()
     if(value === ''){
        this.apiserve.sendevent("location|exploreList", {});
     }
    }
    //role wise filter
    TypeWiseFilter = (e, selectedInex, isClearRoleType = false, isClearFilmType) => {
        let index = selectedInex
        let event = e && e.target && e.target.checked
        let TypeList = [...this.state.TalkandEventType]
        TypeList.forEach((key, i) => {
            if (i === index) {
                TypeList[i].value = event
            }
            if (isClearFilmType) {
                TypeList[i].value = false
                typeWiseFilterData = []
            }

        })
        this.setState({
            ...this.state,
            TalkandEventType: TypeList,
            currentPage: 0
        }, () => {
            if (event) {
                if (index !== null) {
                    typeWiseFilterData = [...typeWiseFilterData, this.state.TalkandEventType[index].assign];
                }
            } else {
                if (index !== null) {
                    let tempArray = typeWiseFilterData.filter((d) => d !== this.state.TalkandEventType[index].assign);
                    typeWiseFilterData = tempArray;
                }
            }
            this.getAllItemFilter(this.state.offset, this.state.perPage, isClearRoleType, isClearFilmType);
        })
    };
    dateChangeForm = (e) => {
        this.setState({
            fromDate: e
        })
    }
    TalkandEventdateChangeForm = (e) => {
        this.setState({
            fromDate: e
        })
    }
    TheaterdateChangeForm=(e)=>{
        this.setState({
            fromDate: e
        })
    }
    dateChangeTo = (e) => {
        this.setState({
            toDate: e
        })
    }
    TalkandEventdateChangeTo = (e) => {
        this.setState({
            toDate: e
        })
    }
    TheaterdateChangeTo=(e)=>{
        this.setState({
            toDate: e
        })
    }
    //Source type filter
    sourceTypeFilter = (e, selectedInex, isClearRoleType = false, isClearItemType) => {
        let index = selectedInex
        let event = e && e.target && e.target.checked
        let sourceList = [...this.state.sourceType]
        sourceList.forEach((key, i) => {
            if (i === index) {
                sourceList[i].value = event
            }
            if (isClearItemType) {
                sourceList[i].value = false
                sourceFilterData = []
            }

        })
        this.setState({
            ...this.state,
            sourceType: sourceList,
            currentPage: 0
        }, () => {
            if (event) {
                if (index !== null) {
                    sourceFilterData = [...sourceFilterData, this.state.sourceType[index].assign];
                }
            } else {
                if (index !== null) {
                    let tempArray = sourceFilterData.filter((d) => d !== this.state.sourceType[index].assign);
                    sourceFilterData = tempArray;
                }
            }
            this.getAllItemFilter(this.state.offset, this.state.perPage);
        })
    };
    getAllItemFilter = (skip, limit, isClearRoleType, isClearItemType) => {
        this.setState({ loaderFlag: true })
        var data = {
            page: 1,
            limit: 50
        }

        if (this.state.searchField.length) {
            data.filter = this.state.searchField
        }

        if (roleWiseFilterData.length) {
            data.role = roleWiseFilterData
        }

        if (itemsWiseFilterData.length) {
            data.pass = itemsWiseFilterData
        }
       
        if (this.state.dateState || this.state.Datetime) {
            let fromDate = new Date(this.state.fromDate)
            let toDate = new Date(this.state.toDate)

            fromDate.setHours(0)
            fromDate.setMinutes(0)
            toDate.setHours(23)
            toDate.setMinutes(59)


            data.fromDate = fromDate
            data.toDate = toDate
        }
        if(this.state.activetab === 2 || this.state.activetab === 1 || this.state.activetab === 4 ){
            if (itemsWiseFilterData.length) {
                delete data['pass']
            }
            if(this.state.activetab === 1){
                if (typeWiseFilterData.length) {
                    data.filmType = typeWiseFilterData
                }
            }
            if(this.state.activetab === 2){
                if (FilmTypeFilterData.length) {
                    data.film = FilmTypeFilterData
                }
                if (screeningTypeFilterData.length) {
                    data.screenType = screeningTypeFilterData
                }
                if (locationFilter.length) {
                    data.location = locationFilter
                    // data.location = []
                }
            }
            data.tab = this.state.activetab
            this.apiserve.sendevent("admin|getUseranalytics", data);
        } else if(this.state.activetab === 3){
            if (screeningFilmFilterData.length) {
                data.film = screeningFilmFilterData
            }
            if (screeningTypeOnlineFilterData.length) {
                data.screenType = screeningTypeOnlineFilterData
            }
            if (locationFilter.length) {
                data.location = locationFilter
                // data.location = []
            }
            if (sourceFilterData.length) {
                data.source = sourceFilterData
            }
            delete data['pass']
            this.apiserve.sendevent("admin|getUserScreening", data);
        } else {
            delete data['location']
            delete data['screenType']
            delete data['film']
            this.apiserve.sendevent("admin|getUserActivities", data);
        }
    }

    TabClick = (index) => {
        this.setState({
            activetab: index,
            searchField:'',
            rolesType: [
                { assign: "sioUser", name: "Industry", value: false },
                { assign: "pressUser", name: "Press", value: false },
                // { assign: "circleUser", name: "Sundance Circle", value: false },
                { assign: 'generalUser', name: 'General', value: false },
                { assign: 'circleGuestUser', name: 'Sundance Guest', value: false },
                { assign: 'artistUser', name: 'Artist', value: false },
            ],
            screeningType: [
                { assign: "1", name: "Premiere", value: false },
                { assign: "2", name: "Second Screening", value: false },
                { assign: "3", name: "Award Winner", value: false },
                { assign: "4", name: "Private Screening", value: false },
                { assign: '5', name: 'Indies Series', value: false },
                { assign: '6', name: 'Short Program', value: false },
            ],
            screeningOnlineType: [
                { assign: "1", name: "Premiere", value: false },
                { assign: "2", name: "Second Screening", value: false },
                { assign: "3", name: "Award Winner", value: false },
                { assign: '4', name: 'Indies Series', value: false },
                { assign: '5', name: 'Shorts', value: false },
                { assign: '6', name: 'My Library', value: false },

            ],
            itemsType: [
                { assign: "hybridAllAccessPass", name: "All Access Pass", value: false },
                { assign: "hybridAllAccessPassFirstHalf", name: "All Access Pass 1st half Pass", value: false },
                { assign: "hybridAllAccessPassSecondHalf", name: "All Access Pass 2nd half", value: false },
                { assign: 'onlineAllAccessPass', name: 'All Access Pass - Online only', value: false },
                { assign: 'hybridPressIndustryPackage', name: 'P&I Package', value: false },
                { assign: 'onlinePressIndustryPackage', name: 'P&I Package - Online only', value: false },
                { assign: 'hybridFestivalPass', name: 'Festival Package', value: false },
                { assign: 'onlineDayPass', name: 'Day Package - Online only', value: false },
                { assign: 'hybridResortPackage', name: 'Resort Package', value: false },
                { assign: 'saltLackCityPackage', name: 'SLC Package', value: false },
                { assign: 'hybridAwardWinnersPass', name: 'Award Winners Weekend', value: false },
                { assign: 'hybridSingleFilmTicket', name: 'Single Ticket', value: false },
                { assign: 'onlineExplorerPass', name: 'Explorer Pass - Online only', value: false }
            ],
            TalkandEventType: [
                { assign: "BeyondFilm", name: "Beyond Film ", value: false },
                { assign: "Frontier", name: "New Frontier", value: false },
                { assign: 'PartnerEvent', name: 'Partner Event', value: false },
                { assign: 'PrivateEvent', name: 'Private Event', value: false },
                { assign: 'ShortProgramme', name: ' Short Programme', value: false },
            ],
        })
        roleWiseFilterData = [];
        FilmTypeFilterData = [];
        screeningTypeFilterData = [];
        screeningTypeOnlineFilterData = [];
        if(index === 6){
            var data = {
                page: 1,
                limit: 50
            }
            this.apiserve.sendevent("admin|getUserActivities", data);
        }
        // this.setState({
        //     rolesType: [
        //         { assign: "sioUser", name: "Industry", value: false },
        //         { assign: "pressUser", name: "Press", value: false },
        //         // { assign: "circleUser", name: "Sundance Circle", value: false },
        //         { assign: 'generalUser', name: 'General', value: false },
        //         { assign: 'circleGuestUser', name: 'Sundance Guest', value: false },
        //         { assign: 'artistUser', name: 'Artist', value: false },
        //     ],
            
        // })
    }

    render() {
        const { getAllUserActivities, getTotalDocs, itemsType, rolesType, getTotalDocsActivities } = this.state
        let dateStringLabel = `${moment(this.state.fromDate).format('MM/DD/YYYY')} - ${moment(this.state.toDate).format('MM/DD/YYYY')}`;
        let dateStringLabelTalkandEvent = `${moment(this.state.fromDate).tz("US/Mountain").format('MM/DD/YYYY')} - ${moment(this.state.toDate).tz("US/Mountain").format('MM/DD/YYYY')}`;
        let dateStringLabelTheaterDatetime = `${moment(this.state.fromDate).tz("US/Mountain").format('MM/DD/YYYY')} - ${moment(this.state.toDate).tz("US/Mountain").format('MM/DD/YYYY')}`;
        return (
            <div className="right_side_wrapper adminDashboard_wrapper">
                <div className="dashboard_header with_btn">
                    {(this.state.activetab !== 5) ?
                    
                        <div className="d_flex d_flex_justify_spacebt d_flex_align_center" style={{ width: "36%" }}>
                            <div className="searchBlock">
                                {
                                    this.state.activetab !== 0 ?
                                    <span>All Users ({this.state.activetab === 6 ? getTotalDocsActivities : getTotalDocs})</span>
                                    :
                                    ''
                                }
                                <form onSubmit={e => { e.preventDefault(); }}>
                                    <input
                                        type="text"
                                        placeholder="Search"
                                        id="searchField"
                                        name="searchField"
                                        value={this.state.searchField}
                                        onChange={this.onSearchFilter}
                                    />
                                    <button type='button'>
                                        <img src={serachIcon} />
                                    </button>
                                </form>
                            </div>
                            {
                                // this.state.activetab !== 0 ?
                                <div className="icon_block">
                                    <Link
                                        onClick={() => this.getCSVData()}
                                    ><img src={cloud} /></Link>
                                </div>
                                // :''
                            }
                        </div>
                        :
                        <div></div>
                    }
                    <div className="button_block admin_user_twoBtn blue_button_wrapper">
                        <>

                            {
                                this.state.userlist && this.state.userlist.map((item, index) => {
                                    return (
                                        <span className={`head_btn pointer ${this.state.activetab === index ? 'active' : ''}`} onClick={() => this.TabClick(index)}>{item.label}</span>
                                    )
                                })
                            }
                        </>

                    </div>

                </div>


                {/* <PurchaseUser />  */}
                {/* {this.state.activetab === 1 ?
                    <Reservation />
                    :
                    ""
                } */}
                {this.state.activetab === 0 ?
                    <Allotments 
                        programFilter={this.programFilter}
                        programArray={this.state.programArray}
                        programFilterList= {programFilterList}
                        allotmentData={this.state.allotmentData}
                        filmDetail={this.state.filmDetail}
                        dropdownId={this.state.dropdownId}
                        grandtotal ={this.state.grandtotal}
                        handlePageClick = {this.handlePageClick}
                        pageCount={this.state.pageCount}
                        getAlotment = {this.getAlotment}
                    /> : ''
                }

                {this.state.activetab === 1 ?
                    <TalksEvents
                        roleWiseFilter={this.roleWiseFilter}
                        rolesType={rolesType}
                        OpenTalkandEventDateFilter={this.OpenTalkandEventDateFilter}
                        TalkandEventclearDateFilter={this.TalkandEventclearDateFilter}
                        TalkandEventFlag={this.state.TalkandEventFlag}
                        TalkandEventFilterModal={this.state.TalkandEventFilterModal}
                        itemsTypeFilter={this.itemsTypeFilter}
                        TalkandEventdateChangeForm={this.TalkandEventdateChangeForm}
                        TalkandEventdateChangeTo={this.TalkandEventdateChangeTo}
                        TalkandEventdateFilter={this.TalkandEventdateFilter}
                        closeTalkandEventModal={this.closeTalkandEventModal}
                        dateStringLabelTalkandEvent={dateStringLabelTalkandEvent}
                        fromDate={this.state.fromDate}
                        toDate={this.state.toDate}
                        TalkandEventfromDate={this.state.TalkandEventfromDate}
                        TalkandEventtoDate={this.state.TalkandEventtoDate}
                        TalkandEventType = {this.state.TalkandEventType}
                        TypeWiseFilter = {this.TypeWiseFilter}
                        roleWiseFilterData ={roleWiseFilterData}
                        handlePageClick= {this.handlePageClick}
                         />
                    :
                    ""
                }

                {this.state.activetab === 2 ?
                    <TheaterDetails 
                    roleWiseFilter={this.roleWiseFilter}
                    roleWiseFilterData={roleWiseFilterData}
                        rolesType={rolesType}
                    OpenTheaterDatetimeDateFilter={this.OpenTheaterDatetimeDateFilter}
                    TheaterDatetimeclearDateFilter={this.TheaterDatetimeclearDateFilter}
                    TheaterDatetimeFlag={this.state.TheaterDatetimeFlag}
                    dateTimeFilterModal={this.state.dateTimeFilterModal}
                    itemsTypeFilter={this.itemsTypeFilter}
                    TheaterdateChangeForm={this.TheaterdateChangeForm}
                    TheaterdateChangeTo={this.TheaterdateChangeTo}
                    TheaterdateFilter={this.TheaterdateFilter}
                    FilmTypeFilter={this.FilmTypeFilter}
                    DatetimecloseModal={this.DatetimecloseModal}
                    dateStringLabelTheaterDatetime={dateStringLabelTheaterDatetime}
                    fromDate={this.state.fromDate}
                    toDate={this.state.toDate}
                    OrignalData={this.state.OrignalData}
                    screeningTypeFilter={this.screeningTypeFilter}
                    screeningType={this.state.screeningType}
                    LocationData={this.state.LocationData}
                    LocationFilterdata = {this.LocationFilterdata}
                    onSearchfilmFilters= {this.onSearchfilmFilters}
                    onSearchlocationFilters = {this.onSearchlocationFilters}
                    searchFilm= {this.state.searchFilm}
                    searchLocation= {this.state.searchLocation}
                    onSearchFilters={this.onSearchFilters}
                    handlePageClick = {this.handlePageClick}
                     />
                    :
                    ""
                }


                {/* <Reservation /> */}
                {this.state.activetab === 3 ?
                    // <h3 className='text_center'>Comming Soon</h3>
                    <ScreeningUser
                    
                    itemsWiseFilterData={itemsWiseFilterData} 
                    FilmTypeFilter={this.FilmTypeFilter}
                    roleWiseFilter={this.roleWiseFilter}
                    roleWiseFilterData={roleWiseFilterData}
                    rolesType={rolesType}
                    screeningOnlineTypeFilter={this.screeningOnlineTypeFilter}
                    screeningOnlineType={this.state.screeningOnlineType}
                    filmFilterType ={this.state.filmFilterType}
                    itemsScreeningTypeFilter = {this.itemsScreeningTypeFilter}
                    sourceType = {this.state.sourceType}
                    sourceTypeFilter = {this.sourceTypeFilter}
                    handlePageClick = {this.handlePageClick}
                    />
                    :
                    ""
                }

                {this.state.activetab === 4 ?
                    // <h3 className='text_center'>Comming Soon</h3>
                    <Voting CloseModal={this.closeModal} 
                    roleWiseFilter={this.roleWiseFilter}
                    rolesType={rolesType}
                    handlePageClick = {this.handlePageClick}
                    />
                    :
                    ""
                }

                {this.state.activetab === 6 ?
                    <PurchaseUser
                        roleWiseFilter={this.roleWiseFilter}
                        itemsTypeFilter={this.itemsTypeFilter}
                        OpenDateFilter={this.OpenDateFilter}
                        OpenReceiptModal={this.OpenReceiptModal}
                        dateFilter={this.dateFilter}
                        dateChangeForm={this.dateChangeForm}
                        dateChangeTo={this.dateChangeTo}
                        handlePageClick={this.handlePageClick}
                        clearDateFilter={this.clearDateFilter}
                        pageCount={this.state.pageCount}
                        currentPage={this.state.currentPage}
                        roleWiseFilterData={roleWiseFilterData}
                        rolesType={rolesType}
                        itemsWiseFilterData={itemsWiseFilterData}
                        dateStringLabel={dateStringLabel}
                        getAllUserActivities={getAllUserActivities}
                        itemsType={itemsType}
                        dateFilterModal={this.state.dateFilterModal}
                        closeModal={this.closeModal}
                        fromDate={this.state.fromDate}
                        toDate={this.state.toDate}
                        dateDisplayFlag={this.state.dateDisplayFlag}
                        OpenUserActiviesModal={this.OpenUserActiviesModal}
                    />
                    :

                    ""
                }

                {/* <Reservation /> */}
                {this.state.activetab === 5 ?
                    <PassTicktes />
                    :
                    ""
                }


                {
                    this.state.purchaseReceipt ?
                        <ReceiptModal CloseModal={this.closeModal} purchaseList={this.state.purchaseList} />
                        :
                        ''
                }
                {
                    this.state.userActivities ?
                        <UserActivitiesModal CloseModal={this.closeModal} submitEmail={this.submitEmail}  validator={ this.validator} email={this.state.email} handleChangeEmail={this.handleChangeEmail} />
                        :
                        ''
                }

                {this.state.loaderFlag ? (
                    <Loader />
                ) : (
                    ""
                )}
            </div>

        )
    }

}
export default connect(mapStateToProps)(UserActivities);
// Please press a Cancel button here not found Device Code